@if (isLoading) {
  <div class="grid grid-cols-1 gap-4">
    @for (i of [1, 2]; track i) {
      <vw-skeleton-loader [width]="'100%'" [height]="'140px'" [borderRadius]="'0.75rem'"></vw-skeleton-loader>
    }
  </div>
} @else {
  <div class="flex flex-col gap-6">
    @for (z of zones; track z.zone.uid) {
      <div class="flex flex-col gap-3">
        <!-- En-tête de zone -->
        <div class="flex items-center gap-2">
          <span class="flex h-8 w-8 items-center justify-center rounded-full bg-primary-50 text-base">📍</span>
          <div class="flex-1">
            <h3 class="text-lg font-semibold text-[#023E42]">{{ z.zone.name }}</h3>
            <p class="text-xs text-[#9DA4A2]">
              @if (z.zone.sunchineLevels) {
                {{ 'garden.beds.enums.exposure.' + z.zone.sunchineLevels | translate }} ·
              }
              {{ 'garden.overview.beds-count' | translate: { count: z.beds.length } }}
            </p>
          </div>
        </div>

        <!-- Planches -->
        @for (b of z.beds; track b.bed.uid) {
          <div (click)="openBed(b.bed)">
            <vw-bed-item [bed]="b.bed" [cultures]="b.cultures" [count]="b.count" [freeCells]="b.freeCells"></vw-bed-item>
          </div>
        }

        <!-- Cultures hors planche de la zone -->
        @if (z.looseCultures.length) {
          <p class="mt-1 text-xs font-medium uppercase tracking-wide text-[#9DA4A2]">
            {{ 'garden.overview.loose-cultures' | translate }}
          </p>
          <div class="grid grid-cols-3 gap-3">
            @for (c of z.looseCultures; track $index) {
              <div (click)="openPlant(c.plant)" class="cursor-pointer">
                <vw-cultivation-item-viewer [cultivation]="$any(c.culture)" displayType="SMALL" [showName]="true"></vw-cultivation-item-viewer>
              </div>
            }
          </div>
        }

        <!-- Ajouter une planche dans cette zone -->
        <button
          type="button"
          class="flex items-center gap-3 rounded-xl border-2 border-dashed border-gray-200 p-3 text-left"
          (click)="addBedToZone(z.zone)"
        >
          <span class="flex h-8 w-8 items-center justify-center rounded-full bg-gray-100 text-[#6B7472]">+</span>
          <span>
            <span class="block text-sm font-medium text-[#023E42]">{{ 'garden.overview.add-bed.title' | translate }}</span>
            <span class="block text-xs text-[#9DA4A2]">{{ 'garden.overview.add-bed.subtitle' | translate }}</span>
          </span>
        </button>
      </div>
    }

    <!-- Cultures sans zone (bloc en bas) -->
    @if (orphanCultures.length) {
      <div class="flex flex-col gap-3 border-t border-gray-100 pt-5">
        <p class="text-xs font-medium uppercase tracking-wide text-[#9DA4A2]">
          {{ 'garden.overview.no-zone' | translate }}
        </p>
        <div class="grid grid-cols-3 gap-3">
          @for (c of orphanCultures; track $index) {
            <div (click)="openPlant(c.plant)" class="cursor-pointer">
              <vw-cultivation-item-viewer [cultivation]="$any(c.culture)" displayType="SMALL" [showName]="true"></vw-cultivation-item-viewer>
            </div>
          }
        </div>
      </div>
    }

    @if (!zones.length && !orphanCultures.length) {
      <p class="py-8 text-center text-sm text-[#9DA4A2]">{{ 'garden.overview.empty' | translate }}</p>
    }
  </div>
}

<!-- Panneau « Ajouter une zone » : réutilise le formulaire de zone existant (slide-in). -->
<div
  class="fixed inset-0 z-[60] overflow-y-auto bg-white px-4 pt-6 transition-transform duration-200 ease-in-out"
  [ngClass]="showZoneForm ? 'translate-x-0' : 'pointer-events-none translate-x-full'"
>
  @if (showZoneForm) {
    <vw-user-adress-location-form [location]="null" (closeLocationForm)="onZoneFormClosed($event)"></vw-user-adress-location-form>
  }
</div>
